export default "__VITE_PUBLIC_ASSET__09b8f97b__"